import { render, staticRenderFns } from "./CompanyRoles.vue?vue&type=template&id=d93348f4&scoped=true&lang=pug&"
import script from "./CompanyRoles.vue?vue&type=script&lang=js&"
export * from "./CompanyRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d93348f4",
  null
  
)

export default component.exports